import React from 'react'

const MobilepaySubscriptionDone = () => {
  return (
    <div>MobilepaysubscriptionDone</div>
  )
}

export default MobilepaySubscriptionDone